export default "__VITE_ASSET__C$4cnDHU__$_?nuxt_component=async&nuxt_component_name=SvgoOnboardingWelcomeToTheCommunity&nuxt_component_export=default__"